"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var Tooltip_1 = require("../Tooltip/Tooltip");
var Link_logic_1 = require("./Link.logic");
/**
 * Link atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-link--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Link Source}
 */
var Link = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, fullWidth = _a.fullWidth, interactiveTooltip = _a.interactiveTooltip, onNavigate = _a.onNavigate, openInNewTab = _a.openInNewTab, tooltip = _a.tooltip, tooltipPlacement = _a.tooltipPlacement, url = _a.url, other = __rest(_a, ["children", "className", "disabled", "fullWidth", "interactiveTooltip", "onNavigate", "openInNewTab", "tooltip", "tooltipPlacement", "url"]);
    var _b = (0, Link_logic_1.useLink)({
        disabled: disabled,
        fullWidth: fullWidth,
        onNavigate: onNavigate,
        openInNewTab: openInNewTab,
        url: url,
    }), handleClick = _b.handleClick, handleKeyDown = _b.handleKeyDown, rootClassName = _b.rootClassName, target = _b.target;
    // TODO: With MUI v5 evaluate prop `followCursor` (see https://github.com/mui-org/material-ui/issues/14270)
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: tooltip, interactive: interactiveTooltip, className: className, placement: tooltipPlacement }, { children: renderLink() })));
    function renderLink() {
        return ((0, jsx_runtime_1.jsx)(core_1.Link, __assign({ "aria-disabled": disabled, href: url, className: rootClassName, target: target, rel: 'noreferrer noopener', onClick: handleClick, onKeyDown: handleKeyDown }, other, { children: children })));
    }
};
exports.Link = Link;
